import {
  AnalyticsIds,
  type AMP,
  type EventProps,
  type EventType,
  type GroupTraits,
  type SourceTouch,
  type UserTraits,
} from "./event_types";

import { version as PACKAGE_VERSION } from "../../package.json";

export interface Session {
  id: string;
  startTime: string | Date;
}

/**
 * Data passed to Plausible as events.
 */
export interface ClientContextData extends SourceTouch {
  page?: {
    path: string;
    referrer: Document["referrer"] | null;
    search?: string;
    title: string;
    url: Location["href"];
  };
  deviceWidth?: Window["innerWidth"];

  // TODO: fill in the rest of the fields

  locale?: string;
  /**
   * {@link https://github.com/segmentio/analytics.js-integrations/blob/2d5c637c022d2661c23449aed237d0d546bf062d/integrations/segmentio/lib/index.js#L292-L301}
   */
  traits?: {
    crossDomainId?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
  initialSource?: SourceTouch;
  amp?: AMP;
  analyticsIds?: AnalyticsIds;
  /** Browser IDs set by ad pixels, keyed by cookie name (e.g. `_fbp`). */
  adCookies?: Record<string, string>;
}

export interface Event {
  messageId?: string;

  // identity
  anonymousId: string;
  userId?: string;

  type: EventType;
  event?: string; // optional for page / screen / identify / group calls
  name?: string;

  properties: EventProps;

  traits?: UserTraits | GroupTraits; // applicable for group and identify calls.
  context: ClientContextData;
  timestamp: string | Date;

  // session
  session?: Session;
}

export interface UploadRequest {
  sourceId?: string;
  events: Event[];
  version: string;
  sentAt: string | Date;
}

const isDev = process.env.NODE_ENV === "development";
export const SYFT_VERSION = PACKAGE_VERSION;
export const DEFAULT_UPLOAD_PATH = isDev
  ? "http://localhost:3000/api/events"
  : "https://e2.sy-d.io/events";

export const ICP_PATH = isDev
  ? "http://localhost:3000/api/syft"
  : "https://app.syftdata.com/api/syft";

// const BETA_ORGS = [
//   "syftdata.com",
//   "getsyft.app",
//   "sybill.ai",
//   "askwonder.com",
//   "arrows.to",
//   "revopscoop.com",
//   "sievedata.com",
//   "tonic.ai",
//   "safegraph.com",
//   "latch.bio",
//   "sternsmith.com",
// ];
// export function isBeta(): boolean {
//   if (process.env.NODE_ENV === "development") return true;
//   const e = window.location.hostname;
//   if (e == null) return false;
//   return BETA_ORGS.some((org) => e.includes(org));
// }
